/**
 * SegmentedControl — the filter-pill control repeated inline on Alerts,
 * Companies, Profile, Professional dashboards. One active segment tinted teal.
 *
 * Props:
 *   options  — [{ key, label, count? }]
 *   value    — active key
 *   onChange — (key) => void
 */
export default function SegmentedControl({ options = [], value, onChange, className = '' }) {
  return (
    <div
      className={`inline-flex gap-1 p-[3px] ${className}`}
      style={{ background: '#f0ece2', borderRadius: 'var(--r-lg)' }}
    >
      {options.map((o) => {
        const active = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange?.(o.key)}
            className="px-4 py-[7px] text-[12.5px] font-semibold whitespace-nowrap transition-all active:scale-[var(--press-scale)]"
            style={{
              borderRadius: 'var(--r-sm)',
              transitionDuration: 'var(--dur-fast)',
              background: active ? '#fff' : 'transparent',
              color: active ? 'var(--teal)' : '#5a5145',
              boxShadow: active ? '0 1px 4px rgba(8,17,31,0.10)' : 'none',
            }}
          >
            {o.label}
            {o.count != null && ` (${o.count})`}
          </button>
        );
      })}
    </div>
  );
}
